import React from "react";
import "../../assets/css/como-participar.css";

interface ComoParticiparComponentProps {
  worldCupData?: any;
}

const ComoParticiparComponent: React.FC<ComoParticiparComponentProps> = ({ worldCupData }) => {
  const getImageUrl = (media: any): string => {
    if (!media) return "";
    const baseUrl = 'https://manager.hyundaicolombia.co';
    return `${baseUrl}${media.url}`;
  };

  const participeCards = worldCupData?.participe_cards || [];

  if (!worldCupData) {
    return null;
  }

  return (
    <section className="como-participar-section" id="como-participar">
      <div className="como-participar-bg">
        <div className="como-participar-bg-right"></div>
      </div>
      
      <div className="como-participar-container">
        
        <h2 className="como-participar-title">{worldCupData.participate_title}</h2>
        <p className="como-participar-subtitle">
          {worldCupData.participe_description}
        </p>
        
        <div className="como-participar-cards">
          {participeCards.map((card: any) => (
            <div key={card.id} className="como-participar-card">
              <div className="como-participar-icon">
                <img src={getImageUrl(card.img)} alt={card.text} />
              </div>
              <p className="como-participar-card-text">
                {card.text}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ComoParticiparComponent;